// @ts-nocheck
import classNames from 'classnames';
import React, { ComponentPropsWithoutRef, ReactElement, useContext, useEffect, useState } from 'react';
import { FloatingHeaderBaseProps } from '../types';
import { FloatingHeaderContext } from '../context/FloatingHeaderContext';
import { NavigationVertical } from './navigation/NavigationVertical';
import { NavigationHorizontal } from './navigation/NavigationHorizontal';
import { HeaderNavigationContext } from '../context/HeaderNavigationContext';

export type HeaderNavigationProps = FloatingHeaderBaseProps & ComponentPropsWithoutRef<'nav'>;

export const HeaderNavigation = ({
  id,
  className,
  children,
  'aria-label': ariaLabel = 'Main Navigation',
  ...otherProps
}: HeaderNavigationProps): ReactElement => {
  const { overlayIsOpen, showHorizontalMenu } = useContext(FloatingHeaderContext);
  const { setActiveMenuID } = useContext(HeaderNavigationContext);
  const [isScrolled, setIsScrolled] = useState(false);
  const containerClasses = classNames('lmig-FloatingHeader-nav', className, {
    'lmig-FloatingHeader-nav-vertical--isOpen': overlayIsOpen,
    'lmig-FloatingHeader-nav-vertical': !showHorizontalMenu,
    'lmig-FloatingHeader-nav-vertical--scrolled': isScrolled,
  });

  /** This adds the scrolled modifying class to apply the box-shadow */
  const handleScroll = (event: React.UIEvent<HTMLElement>): void => {
    const { target } = event;
    const { scrollTop } = target as Element;
    if (scrollTop <= 0) {
      setIsScrolled(false);
    }

    if (scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
  };

  const NavChildComponent = showHorizontalMenu ? NavigationHorizontal : NavigationVertical;
  const childProps = showHorizontalMenu ? {} : { isOpen: overlayIsOpen };

  // Resetting activeMenuID when the NavigationHorizontal is unmounted.
  // This is used for resetting the default border-bottom-radius on window resize.
  useEffect(() => {
    if (showHorizontalMenu === false) {
      setActiveMenuID('');
    }
  }, [setActiveMenuID, showHorizontalMenu]);

  return (
    <nav
      id={id}
      className={containerClasses}
      aria-label={ariaLabel}
      {...(overlayIsOpen && { onScroll: handleScroll })}
      {...otherProps}
    >
      <NavChildComponent {...childProps} className="lmig-FloatingHeader-nav-menu">
        {children}
      </NavChildComponent>
    </nav>
  );
};
